import PropTypes from 'prop-types';
import styles from './SectionTitle.module.css';


const SectionTitle = ({title, color }) => {
    return (
        <h2 
            className={styles.SectionTitle}
            style={{color: `${color ?? '#0F192D'}`}}
        >
            {title}
        </h2>
    );
};

export default SectionTitle;

// type checking 
SectionTitle.propTypes = {
    title: PropTypes.string.isRequired,
    color: PropTypes.string
}